import { Button, Group, Paper, Stack, Text } from '@mantine/core';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface ValidationModeChoiceProps {
  fieldsCount: number;
  canSkipAllOrganic: boolean;
  isPending: boolean;
  onYes: () => void;
  onNo: () => void;
}

export const ValidationModeChoice: FC<ValidationModeChoiceProps> = ({
  fieldsCount,
  canSkipAllOrganic,
  isPending,
  onYes,
  onNo,
}) => {
  const { t } = useTranslation();

  return (
    <Paper p="lg">
      <Stack gap="lg">
        <Text fw={600} size="lg" ta="center">
          {t('farmer-validation.choice-question')}
        </Text>
        <Text c="dimmed" size="sm" ta="center">
          {t('farmer-validation.choice-fields-hint', { count: fieldsCount })}
        </Text>

        <Group grow>
          <Button onClick={onYes} size="lg" variant="default">
            {t('common.yes')}
          </Button>
          <Button
            disabled={!canSkipAllOrganic}
            loading={isPending}
            onClick={onNo}
            size="lg"
          >
            {t('common.no')}
          </Button>
        </Group>

        {!canSkipAllOrganic ? (
          <Text c="dimmed" size="sm" ta="center">
            {t('farmer-validation.choice-no-disabled-hint')}
          </Text>
        ) : null}
      </Stack>
    </Paper>
  );
};
